import script from "./dialog-join-us.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-join-us.vue?vue&type=script&setup=true&lang=js"

import "./dialog-join-us.vue?vue&type=style&index=0&id=2aff4c14&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aff4c14"]])

export default __exports__